import Lenis from "@studio-freight/lenis";

export const smoothScroll = () => {
    const lenis = new Lenis();

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    // If it's the homepage, always start at the top of the page - no jumping ahead of the hero animation
    document.body.classList.contains("page-homepage") && lenis.scrollTo(0);

    const scrollers = document.querySelectorAll("[data-scrollto]");
    scrollers &&
        scrollers.forEach(scroller => {
            const options = {
                easing: x => (x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2),
            };
            options.duration =
                window.innerWidth < 960 && scroller.classList.contains("hero-homepage__scrollto") ? 1.6 : 0.6;
            scroller.addEventListener("click", () => lenis.scrollTo("#" + scroller.dataset.scrollto, options));
        });

    document.addEventListener("menuToggled", e => {
        e.detail.isOpen ? lenis.stop() : lenis.start();
    });

    document.addEventListener("resizing", e => {
        const { width } = e.detail;
        // If we resize to desktop and we're currently in a locked state from having the mobile menu open, unlock scroll
        width >= 960 && lenis.isStopped && lenis.start();
    });
};
